import React from 'react'
import { Box, Button } from '@mui/material'
import { useHistory } from 'react-router-dom'
import routes from '../../routes/routes'

export function PartnerBackButton({ isNewPartner = false }) {
  const history = useHistory()

  const onBack = () => {
    history.push(routes.partners.list)
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, mb: 2 }}>
      <Button variant="contained" color="primary" onClick={onBack}>
        {isNewPartner ? 'Atcelt' : 'Atgriezties partneru sarakstā'}
      </Button>
    </Box>
  )
}
